// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"FlexContainer_flexContainer__26U7-"};